import { useEffect, useRef } from 'react';
import '../../../js/games.js';

interface GameHostProps {
  id: string;
}

export function GameHost({ id }: GameHostProps) {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.innerHTML = '';
    const previousToast = window.toast;
    window.toast = (message: string) => {
      const node = document.createElement('div');
      node.className = 'toast game-toast';
      node.textContent = message;
      document.body.appendChild(node);
      window.setTimeout(() => node.remove(), 2400);
    };
    const mounted = window.Games?.renderGameInto(id, root);
    if (!mounted) {
      root.innerHTML = '<div class="game-error">Dieses Spiel konnte nicht geladen werden.</div>';
    }

    return () => {
      root.innerHTML = '';
      window.toast = previousToast;
    };
  }, [id]);

  return <div ref={rootRef} className="react-game-host" />;
}
